export enum TypeOfDelivery {
    Normal = 1,
    Cesarean = 2,
    Forceps = 3,
    AnestheticUsed=4
  }